import { createContext, useContext, useState } from "react";
import { collection, addDoc, doc, getDocs, getDoc } from "firebase/firestore";
import { db } from "../Data/Uploader";
import toast from "react-hot-toast";

const OrderContext = createContext();

export function OrderContextProvider({ children }) {
  const [order, setOrder] = useState(null);

  async function getOrder(id) {
    try {
      const docRef = doc(db, "orders", id);

      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // console.log(docSnap.data());
        setOrder({ ...docSnap.data(), id });
      } else {
        throw new Error("No such document!");
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error.message);
    }
  }

  async function getOrders() {
    const querySnapshot = await getDocs(collection(db, "orders"));
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      console.log(doc.id, " => ", doc.data());
    });
  }

  async function createOrder(orderObject) {
    try {
      const docRef = await addDoc(collection(db, "orders"), orderObject);
      if (docRef.id) {
        toast.success("order created successfully");
        return docRef.id;
      } else {
        throw new Error("order could not be created");
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error.message);
    }
  }
  return (
    <OrderContext.Provider
      value={{ createOrder, order, setOrder, getOrder, getOrders }}
    >
      {children}
    </OrderContext.Provider>
  );
}

export function useOrdersContext() {
  const context = useContext(OrderContext);
  if (context === undefined)
    throw new Error("orderContext cannot be used outside orderContextProvider");
  return context;
}
